import { useEffect, useState } from "react";
import type { StoryReaderLayout } from "../readingLayout";

const QUERY = "(min-width: 769px)";

function readLayout(): StoryReaderLayout {
  if (typeof window === "undefined" || !window.matchMedia) return "spread";
  return window.matchMedia(QUERY).matches ? "spread" : "single";
}

export function useStoryReaderLayout(): StoryReaderLayout {
  const [layout, setLayout] = useState<StoryReaderLayout>(readLayout);

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setLayout(mq.matches ? "spread" : "single");
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return layout;
}
